/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
});

import axios from 'axios';
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 302 && typeof error.response.data.redirect_url !== 'undefined') {
        location.href = error.response.data.redirect_url;
        return true;
    }
    return Promise.reject(error)
})
window.axios = axios;

import Alpine from 'alpinejs';
window.Alpine = Alpine;
document.addEventListener("DOMContentLoaded", function(event) {
    Alpine.start();
});

import bulmaCalendar from 'bulma-calendar/dist/js/bulma-calendar.min.js';
window.bulmaCalendar = bulmaCalendar;

window.dayjs = require('dayjs');
var relativeTime = require('dayjs/plugin/relativeTime');
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
window.dayjs.extend(relativeTime);
window.dayjs.extend(utc);
window.dayjs.extend(timezone);

import Tagify from '@yaireo/tagify';

window.Tagify = Tagify;
window.getTags = function () {
    if (typeof window.tagifyObj === 'undefined') {
        return [];
    }
    if (window.tagifyObj.value.length < 1) {
        return [];
    }

    return window.tagifyObj.value.map((el) => el.value);
}
window.initTags = function (el, tags, whitelist) {
    window.tagifyObj = new window.Tagify(el, {
        enforceWhitelist: false,
        whitelist: whitelist,
        skipInvalid: true,
        pattern: /^[a-zA-Z0-9-_]+$/, // Alphanumeric + underscore & dash
    });
    window.tagifyObj.addTags(tags);
}

import swal from 'sweetalert';
